import React from 'react';
import IProps from './interface';

const IconRectangle = ({ color, className, style, size = 8 }: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...style}
    >
      <rect width="8" height="8" rx="1" fill={color} />
    </svg>
  );
};

export default IconRectangle;
